import { BlockStack, InlineStack, Text } from '@shopify/polaris';

interface IProps {
  description: string | string[];
}

export const GSetupGuideItemDescription: React.FC<IProps> = ({ description }) => {
  if (!Array.isArray(description)) {
    return (
      <Text as="p" variant="bodyMd">
        {description}
      </Text>
    );
  }

  return (
    <BlockStack gap="100">
      {description.map((line) => (
        <InlineStack key={line} gap="200" align="start" blockAlign="start" wrap={false}>
          <span className="mt-[7px] size-[3px] shrink-0 rounded-full bg-icon" />

          <Text as="p" variant="bodyMd">
            {line}
          </Text>
        </InlineStack>
      ))}
    </BlockStack>
  );
};
